module.exports = __webpack_public_path__ + "static/media/udemy.64167987.svg";